"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiversityRoutes = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_router_dom_1 = require("react-router-dom");
const styled_components_1 = __importDefault(require("styled-components"));
const hooks_1 = require("../../hooks");
const molecules_1 = require("../../molecules");
const DiversityOnboarding_1 = __importDefault(require("../DiversityOnboarding"));
const DiversitySettingsPreviewPage_1 = __importDefault(require("../DiversitySettingsPreviewPage"));
const DiversitySettingsSkipPage_1 = __importDefault(require("../DiversitySettingsSkipPage"));
const PhenotypeSelectionPage_1 = __importDefault(require("../PhenotypeSelectionPage"));
const SkinToneSelectionPage_1 = __importDefault(require("../SkinToneSelectionPage"));
var DiversityRoutes;
(function (DiversityRoutes) {
    DiversityRoutes["Onboarding"] = "/onboarding";
    DiversityRoutes["SettingsPreview"] = "/settings-preview";
    DiversityRoutes["SettingsSkip"] = "/settings-skip";
    DiversityRoutes["Phenotype"] = "/phenotype";
    DiversityRoutes["SkinTone"] = "/skin-tone";
})(DiversityRoutes || (exports.DiversityRoutes = DiversityRoutes = {}));
function DiversityOverlay() {
    const { state } = (0, hooks_1.useDiversityOverlay)();
    const { Onboarding, Phenotype, SettingsPreview, SettingsSkip, SkinTone } = DiversityRoutes;
    return ((0, jsx_runtime_1.jsxs)(Container, { "data-e2e": 'DiversityOverlay_Container', children: [(0, jsx_runtime_1.jsx)(molecules_1.SkipOrCloseButton, { "data-e2e": 'DiversityOverlay_SkipOrCloseButton' }), (0, jsx_runtime_1.jsx)(Content, { "data-e2e": 'DiversityOverlay_Content', children: (0, jsx_runtime_1.jsxs)(react_router_dom_1.Routes, { "data-e2e": 'DiversityOverlay_Routes', children: [(state === null || state === void 0 ? void 0 : state.isOnboarding) && ((0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: Onboarding, element: (0, jsx_runtime_1.jsx)(DiversityOnboarding_1.default, {}), "data-e2e": 'DiversityOverlay_Route' })), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: Phenotype, element: (0, jsx_runtime_1.jsx)(PhenotypeSelectionPage_1.default, {}), "data-e2e": 'DiversityOverlay_Route' }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: SkinTone, element: (0, jsx_runtime_1.jsx)(SkinToneSelectionPage_1.default, {}), "data-e2e": 'DiversityOverlay_Route' }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: SettingsPreview, element: (0, jsx_runtime_1.jsx)(DiversitySettingsPreviewPage_1.default, {}), "data-e2e": 'DiversityOverlay_Route' }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: SettingsSkip, element: (0, jsx_runtime_1.jsx)(DiversitySettingsSkipPage_1.default, {}), "data-e2e": 'DiversityOverlay_Route' })] }) }), (0, jsx_runtime_1.jsx)(molecules_1.DiversityOverlayNavigation, { "data-e2e": 'DiversityOverlay_DiversityOverlayNavigation' })] }));
}
exports.default = DiversityOverlay;
const Container = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  height: 100vh;
  width: 100vw;
  background: ${({ theme }) => theme.primary};
`;
const Content = styled_components_1.default.div `
  flex-grow: 1;
`;
